import { useState } from "react";
import { type EditorOps } from "./editorCore";

export const useExposure = (
  ops: EditorOps,
  setOps: (ops: EditorOps) => void
) => {
  const [exposure, setExposure] = useState(ops.exposicion ?? 0);

  const handleChange = (value: number) => {
    setExposure(value);
    setOps({ ...ops, exposicion: value });
  };

  const reset = () => {
    setExposure(0);
    setOps({ ...ops, exposicion: undefined });
  };

  const control = (
    <div>
      <label>Exposición</label>
      <input
        type="range"
        min={-100}
        max={100}
        value={exposure}
        onChange={(e) => handleChange(+e.target.value)}
      />
      <button className="btn btn-default" onClick={reset}>
        Reset
      </button>
    </div>
  );

  return {
    control,
    onMouseDown: undefined,
    onMouseMove: undefined,
    onMouseUp: undefined,
    renderOverlay: undefined,
  };
};
